import React from 'react';
import './MainLoader.css';

const MainLoaderCourse = () => {
  return (
    <div id="main-cover-spin">
      <div className="text-center main-spin">
        <div
          className="qg-upload-loader"
          role="status"
          aria-label="Uploading"
        >
          <span className="qg-dot qg-dot-1"></span>
          <span className="qg-dot qg-dot-2"></span>
          <span className="qg-dot qg-dot-3"></span>
          <span className="qg-dot qg-dot-4"></span>
          <span className="qg-dot qg-dot-5"></span>
          <span className="qg-dot qg-dot-6"></span>
        </div>

        <h5 className="qg-upload-text">Uploading...</h5>
      </div>
    </div>
  );
};

export default MainLoaderCourse;